// extracted by mini-css-extract-plugin
export default {"container":"IntegrationPlaceholder_container__hqsmp","future":"IntegrationPlaceholder_future__RyeBl"};